var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SimplePDFViewer',{key:_vm.messages.patientDoc,attrs:{"docURL":(_vm.messages.patientDoc ? _vm.messages.patientDoc : _vm.fname),"height":"100%"}})}
var staticRenderFns = []

export { render, staticRenderFns }